<div class="export-wizard-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{'Export to Excel' | translate}}</h2>
    <button mat-icon-button (click)="onCancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="controls-section">
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>{{'Search columns' | translate}}</mat-label>
        <input matInput [(ngModel)]="searchQuery" (ngModelChange)="updateSelectAllState()">
      </mat-form-field>

      <div class="filter-chips">
        <div class="chip-container">
          <button mat-button [class.active]="showFilter === showFilterEnum.All"
            (click)="updateSelectAllState(showFilterEnum.All)">
            {{'All' | translate}}
          </button>
          <button mat-button [class.active]="showFilter === showFilterEnum.Selected"
            (click)="updateSelectAllState(showFilterEnum.Selected)">
            {{'Selected' | translate}}
          </button>
          <button mat-button [class.active]="showFilter === showFilterEnum.Unselected"
            (click)="updateSelectAllState(showFilterEnum.Unselected)">
            {{'Unselected' | translate}}
          </button>
        </div>
      </div>
    </div>

    <div class="selection-header">
      <mat-checkbox [checked]="selectAll"
        [indeterminate]="!selectAll && selectedCount > 0"
        (change)="toggleSelectAll()">
        {{'Select All' | translate}}
      </mat-checkbox>
      <button mat-button (click)="selectViewColumns()" class="view-columns-btn">
        <mat-icon>visibility</mat-icon>
        {{'Reset to View' | translate}}
      </button>
      <span class="selection-count">{{selectedCount}} / {{exportColumns.length}}</span>
    </div>

    <div class="columns-grid">
      @for (column of filteredColumns; track trackByIndex($index)) {
        <div class="column-item">
          <mat-checkbox [(ngModel)]="column.selected" (change)="onColumnToggle()">
            {{column.displayName}}
          </mat-checkbox>
        </div>
      }
    </div>

    @if (filteredColumns.length === 0) {
      <div class="empty-state">
        <mat-icon>search_off</mat-icon>
        <p>{{'No columns found' | translate}}</p>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{'Cancel' | translate}}
    </button>
    <button mat-raised-button color="primary" (click)="onExport()" [disabled]="selectedCount === 0">
      <mat-icon>download</mat-icon>
      {{'Export' | translate}} ({{selectedCount}})
    </button>
  </mat-dialog-actions>
</div>